import React from 'react';

const Dashboard: React.FC<{ onTenantSelect?: (tenantId: string) => void }> = () => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: '#6c757d',
      fontSize: '1.1rem'
    }}>
      Welcome to your dashboard
    </div>
  );
};

export default Dashboard;